const getMonth = (date: Date): string => {
  const month = date.getMonth() + 1;
  return month > 9 ? month.toString() : `0${month.toString()}`;
};

const getDate = (date: Date): string => {
  const day = date.getDate();
  return day > 9 ? day.toString() : `0${day.toString()}`;
};

const getHours = (date: Date): string => {
  const hours = date.getHours();
  return hours > 9 ? hours.toString() : `0${hours.toString()}`;
};

const getMinutes = (date: Date): string => {
  const minutes = date.getMinutes();
  return minutes > 9 ? minutes.toString() : `0${minutes.toString()}`;
};

const getSeconds = (date: Date): string => {
  const seconds = date.getSeconds();
  return seconds > 9 ? seconds.toString() : `0${seconds.toString()}`;
};

type PatternType = 'yyyy-mm-dd' | 'dd.mm.yyyy';

export default (
  date: Date,
  pattern: PatternType = 'yyyy-mm-dd',
): string => {
  if (!date) {
    return undefined;
  }
  if (pattern === 'dd.mm.yyyy') {
    return `${getDate(date)}.${getMonth(date)}.${date.getFullYear()}`;
  }
  return `${date.getFullYear()}-${getMonth(date)}-${getDate(date)}`;
};

export const mapDateTime = (date: Date | null | undefined): string | undefined => (!date
  ? undefined
  // eslint-disable-next-line max-len
  : `${getDate(date)}.${getMonth(date)}.${date.getFullYear()} ${getHours(date)}:${getMinutes(date)}:${getSeconds(date)}`);

// "yyyy-MM-ddThh:mm:ss"
export const mapDateToStringInput = (date: Date | null | undefined): string | null => (!date
  ? null
  // eslint-disable-next-line max-len
  : `${date.getFullYear()}-${getMonth(date)}-${getDate(date)}T${getHours(date)}:${getMinutes(date)}:${getSeconds(date)}`);
